// 修改后的 Vue 组件
<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.companyId" placeholder="请选择" filterable clearable>
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search"> 查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd"> 新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" label="id" width="100" />
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime * 1000 | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户id" />
        <el-table-column prop="companyId" label="公司">
          <template slot-scope="scope">
            {{ companyMap[scope.row.companyId] || '加载中...' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            {{ {0: "正常", 1: "删除", 2: "待审核"}[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="handleCommand({ cmd: 'view', row: scope.row })">
              查看详情/操作
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="viewVisible" :close-on-click-modal="false" title="详情">
      <el-descriptions column="1" size="mini">
        <el-descriptions-item label="userId">{{ viewUser.id }}</el-descriptions-item>
        <el-descriptions-item label="nickname">{{ viewUser.nickname }}</el-descriptions-item>
        <el-descriptions-item label="email">{{ viewUser.email }}</el-descriptions-item>
        <el-descriptions-item label="walletAddress">{{ viewUser.walletAddress }}</el-descriptions-item>
        <el-descriptions-item label="roles">{{ viewUser.roles }}</el-descriptions-item>
      </el-descriptions>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleEdit(viewUser.iid)">删除</el-button>
        <el-button @click.native="viewVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 新增弹窗 -->
    <el-dialog :visible.sync="addFormVisible" :close-on-click-modal="false" title="新增">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="80px">
        <el-form-item label="地址/邮箱" prop="address">
          <el-input v-model="addForm.address" />
        </el-form-item>
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="addForm.companyId" placeholder="请选择" filterable clearable>
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button :loading="addLoading" type="primary" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "CompanyCertify",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {
        page: 1,
        limit: 20,
        total: 0,
      },
      filters: {},

      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addFormRules: {
        address: [{required: true, message: "请输入地址/邮箱", trigger: "blur"}],
        companyId: [{required: true, message: "请选择公司", trigger: "change"}],
      },
      addLoading: false,

      viewVisible: false,
      viewUser: {},

      // 公司数据缓存
      companyList: [],
      companyMap: {},
      companyLoading: false,
    };
  },
  async mounted() {
    mainHeight(this);
    await this.loadCompanyList();
    this.list();
  },
  methods: {
    // 加载公司列表的方法
    async loadCompanyList() {
      // 先检查是否有缓存数据
      const cachedData = this.getCachedCompanyData();
      if (cachedData) {
        this.companyList = cachedData.list;
        this.companyMap = cachedData.map;
        return;
      }

      // 没有缓存数据，从 API 获取
      this.companyLoading = true;

      try {
        const res = await this.axios.form("/api/admin/company/listall", {
          page: 1,
          limit: 10000,
        });

        this.companyList = res.results || [];
        this.companyMap = this.generateCompanyMap(this.companyList);

        // 缓存数据到本地
        this.cacheCompanyData(this.companyList, this.companyMap);
      } catch (error) {
        // 如果请求失败，设置空数组避免页面报错
        this.companyList = [];
        this.companyMap = {};
      } finally {
        this.companyLoading = false;
      }
    },

    // 生成公司映射对象
    generateCompanyMap(companyList) {
      return companyList.reduce((map, item) => {
        map[item.id] = item.name;
        return map;
      }, {});
    },

    // 缓存公司数据到内存
    cacheCompanyData(list, map) {
      // 使用 window 对象存储，这样在同一个浏览器会话中可以共享
      window._companyCache = {
        list: list,
        map: map,
        timestamp: Date.now()
      };
    },

    // 获取缓存的公司数据
    getCachedCompanyData() {
      const cache = window._companyCache;
      if (!cache) return null;

      // 检查缓存是否过期（例如30分钟）
      const cacheExpiry = 30 * 60 * 1000; // 30分钟
      if (Date.now() - cache.timestamp > cacheExpiry) {
        // console.log('公司数据缓存已过期');
        window._companyCache = null;
        return null;
      }

      return cache;
    },

    // 强制刷新公司数据
    async refreshCompanyData() {
      window._companyCache = null;
      await this.loadCompanyList();
    },

    search() {
      this.page.page = 1;
      this.list();
    },
    handleCommand(cmd) {
      if (cmd.cmd === "view") {
        this.getUser(cmd.row);
      }
    },
    getUser(row) {
      this.axios
        .get(`/api/admin/user/${row.userId}`)
        .then((data) => {
          this.viewUser = Object.assign({}, data);
          this.viewUser.iid = row.id;
          this.viewVisible = true;
        })
        .catch((rsp) => {
          this.$notify.error({title: "错误", message: rsp.message});
        });
    },
    list() {
      this.listLoading = true;
      const params = {
        ...this.filters,
        page: this.page.page,
        limit: this.page.limit,
      };
      this.axios
        .form("/api/admin/user-company/list", params)
        .then((data) => {
          this.results = data.results;
          this.page = data.page;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.addLoading = true;
        this.axios
          .form("/api/admin/user-company/create", this.addForm)
          .then(() => {
            this.$message({message: "提交成功", type: "success"});
            this.addFormVisible = false;
            this.list();
          })
          .catch((rsp) => {
            this.$notify.error({title: "错误", message: rsp.message});
          })
          .finally(() => {
            this.addLoading = false;
          });
      });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleEdit(id) {
      this.axios
        .form(`/api/admin/user-company/delete/${id}`)
        .then(() => {
          this.$message({message: "提交成功", type: "success"});
          this.list();
        })
        .catch((rsp) => {
          this.$notify.error({title: "错误", message: rsp.message});
        });
    },
  },
};
</script>

<style scoped></style>
